export default [
  {
    path: `/`,
    redirect: `/orders`
  }
];
